import { render, staticRenderFns } from "./TermFinalMismatch.vue?vue&type=template&id=5fcdf1bf"
import script from "./TermFinalMismatch.vue?vue&type=script&lang=js"
export * from "./TermFinalMismatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports